import { Controller } from '@hotwired/stimulus'
import { createPopper } from '@popperjs/core'

export default class extends Controller {
  static values = {
    url: String,
    width: { type: String, default: '300px' }
  }

  connect() {
    this.popoverElement = null
    this.popperInstance = null
    this.hideTimeout = null
    this.loading = false

    this.element.addEventListener('mouseenter', this.show.bind(this))
    this.element.addEventListener('mouseleave', this.scheduleHide.bind(this))
  }

  disconnect() {
    this.destroyPopover()
  }

  show() {
    this.cancelHide()

    if (this.popoverElement) {
      this.popoverElement.style.display = 'block'
      this.popperInstance?.update()
      this.loadContent()
      return
    }

    this.createPopover()
  }

  scheduleHide() {
    this.hideTimeout = setTimeout(() => {
      this.hidePopover()
    }, 150)
  }

  cancelHide() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  hidePopover() {
    if (this.popoverElement) {
      this.popoverElement.style.display = 'none'
    }
  }

  createPopover() {
    this.popoverElement = document.createElement('div')
    this.popoverElement.className = 'ajax-popover'
    this.popoverElement.style.width = this.widthValue
    this.popoverElement.innerHTML = `
      <div class="ajax-popover-arrow" data-popper-arrow></div>
      <div class="ajax-popover-body">
        <div class="text-center py-2">
          <div class="spinner-border spinner-border-sm"></div>
        </div>
      </div>
    `

    document.body.appendChild(this.popoverElement)

    this.popoverElement.addEventListener('mouseenter', this.cancelHide.bind(this))
    this.popoverElement.addEventListener('mouseleave', this.scheduleHide.bind(this))

    this.popperInstance = createPopper(this.element, this.popoverElement, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        },
        {
          name: 'arrow',
          options: {
            padding: 8
          }
        }
      ]
    })

    this.loadContent()
  }

  loadContent() {
    if (this.loading) return
    this.loading = true

    // Show spinner while loading
    const body = this.popoverElement?.querySelector('.ajax-popover-body')
    if (body) {
      body.innerHTML = `
        <div class="text-center py-2">
          <div class="spinner-border spinner-border-sm"></div>
        </div>
      `
    }

    fetch(this.urlValue, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.text())
      .then(html => {
        this.setContent(html)
      })
      .catch(error => {
        console.error('Error loading popover content:', error)
        this.setContent('Error loading content')
      })
      .finally(() => {
        this.loading = false
      })
  }

  setContent(html) {
    if (this.popoverElement) {
      const body = this.popoverElement.querySelector('.ajax-popover-body')
      if (body) {
        body.innerHTML = html
        this.popperInstance?.update()
      }
    }
  }

  destroyPopover() {
    this.cancelHide()

    if (this.popperInstance) {
      this.popperInstance.destroy()
      this.popperInstance = null
    }

    if (this.popoverElement) {
      this.popoverElement.remove()
      this.popoverElement = null
    }
  }
}
